(function () {
  'use strict';

  const DRAWER_ID = 'mini-cart-drawer';
  const SECTION_ID = 'mini-cart-drawer';
  const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)\.js/;

  function isCartPage() {
    return document.body && document.body.classList.contains('template-cart');
  }

  let refreshTimer = null;
  let lastTriggerWasAdd = false;
  let suppressOpenOnNextRefresh = false;
  let inflightRefresh = null;
  let pendingCart = null;
  let reconciling = false;

  function getDrawer() {
    return document.querySelector('overlay-drawer#' + DRAWER_ID);
  }

  function getDrawerInner() {
    const drawer = getDrawer();
    return drawer ? drawer.querySelector('.overlay-drawer__inner') : null;
  }

  function setLoading(state) {
    const miniCart = document.querySelector('[data-mini-cart]');
    if (!miniCart) return;
    miniCart.classList.toggle('is-loading', !!state);
  }

  function updateHeaderCount(count) {
    const nodes = document.querySelectorAll('[data-header-cart-count]');
    nodes.forEach(function (node) {
      if (count > 0) {
        node.setAttribute('data-header-cart-count', count);
        node.textContent = '';
        node.classList.add('visible');
      } else {
        node.setAttribute('data-header-cart-count', '');
        node.textContent = '';
        node.classList.remove('visible');
      }
    });
  }

  function parseCount(cartJson) {
    if (cartJson && typeof cartJson.item_count === 'number') return cartJson.item_count;
    return 0;
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  function refreshDrawer(options) {
    options = options || {};
    const open = options.open !== false;
    const cartData = options.cart || null;

    if (open && !suppressOpenOnNextRefresh) openDrawer();
    suppressOpenOnNextRefresh = false;

    if (cartData && typeof cartData.item_count === 'number') {
      updateHeaderCount(cartData.item_count);
    }

    if (inflightRefresh) {
      if (cartData) pendingCart = cartData;
      return inflightRefresh;
    }

    setLoading(true);

    inflightRefresh = fetch(window.location.pathname + '?sections=' + SECTION_ID, {
      credentials: 'same-origin',
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        const html = data && data[SECTION_ID];
        if (!html) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('overlay-drawer#' + DRAWER_ID);
        if (!newDrawer) return;
        const newInner = newDrawer.querySelector('.overlay-drawer__inner');
        const inner = getDrawerInner();
        if (newInner && inner) {
          inner.innerHTML = newInner.innerHTML;
        }
      })
      .then(function () {
        if (cartData) return;
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateHeaderCount(parseCount(cart)); })
          .catch(function () {});
      })
      .catch(function (err) {
        console.warn('[mini-cart] refresh failed', err);
      })
      .finally(function () {
        setLoading(false);
        inflightRefresh = null;
        if (pendingCart) {
          updateHeaderCount(parseCount(pendingCart));
          pendingCart = null;
        }
      });

    return inflightRefresh;
  }

  function scheduleRefresh(opts) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refreshDrawer(opts); }, 0);
  }

  function getCartSectionId() {
    const el = document.querySelector('[data-section-type="static-cart"]');
    return (el && el.getAttribute('data-section-id')) || 'main';
  }

  function batchRemove(keys, sections) {
    const updates = {};
    keys.forEach(function (key) { updates[key] = 0; });
    const body = { updates: updates };
    if (sections) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }
    reconciling = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { reconciling = false; return cart; })
      .catch(function (err) {
        reconciling = false;
        console.warn('[mini-cart] remove failed', err);
        return null;
      });
  }

  function collectLinkedKeys(trigger) {
    const line = trigger.closest('[data-mini-cart-item], [data-cartitem]');
    if (!line) return [];
    const key = line.getAttribute('data-cartitem-key');
    if (!key) return [];
    const keys = [key];
    const variantId = line.getAttribute('data-variant-id') || line.getAttribute('data-cartitem-id');
    if (variantId) {
      document
        .querySelectorAll('[data-ao-parent-variant="' + variantId + '"]')
        .forEach(function (child) {
          if (child.getAttribute('data-ao-final-price') !== '0') return;
          const childKey = child.getAttribute('data-cartitem-key');
          if (childKey && keys.indexOf(childKey) === -1) keys.push(childKey);
        });
    }
    return keys;
  }

  function applyDrawerSection(html) {
    if (!html) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newDrawer = doc.querySelector('overlay-drawer#' + DRAWER_ID);
    const newInner = newDrawer && newDrawer.querySelector('.overlay-drawer__inner');
    const inner = getDrawerInner();
    if (newInner && inner) {
      inner.innerHTML = newInner.innerHTML;
      return true;
    }
    return false;
  }

  function applyCartPageSection(html) {
    if (!html) return false;
    const liveList = document.querySelector('[data-html="list"]');
    if (!liveList) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newList = doc.querySelector('[data-html="list"]');
    if (!newList) return false;
    const liveForm = liveList.closest('form');
    const newForm = newList.closest('form');
    if (liveForm && newForm) {
      liveForm.innerHTML = newForm.innerHTML;
    } else {
      liveList.innerHTML = newList.innerHTML;
    }
    return true;
  }

  function cartPageForm() {
    const liveList = document.querySelector('[data-html="list"]');
    return liveList ? liveList.closest('form') : null;
  }

  function fadeElement(el, on) {
    if (!el) return;
    el.style.transition = 'opacity 0.2s ease';
    el.style.opacity = on ? '0.55' : '';
  }

  function reconcileAddons() {
    if (reconciling) return Promise.resolve(false);
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        const items = (cart && cart.items) || [];
        const presentVariants = new Set();
        items.forEach(function (item) { presentVariants.add(item.variant_id); });

        const orphanKeys = [];
        items.forEach(function (item) {
          const parent = item.properties && item.properties._ao_parent_variant;
          if (!parent) return;
          if (item.final_price !== 0) return;
          if (!presentVariants.has(Number(parent))) orphanKeys.push(item.key);
        });

        if (orphanKeys.length === 0) return false;
        return batchRemove(orphanKeys).then(function (result) { return !!result; });
      })
      .catch(function (err) {
        console.warn('[mini-cart] add-on reconcile fetch failed', err);
        return false;
      });
  }

  function refreshCartPage() {
    const target = document.querySelector('[data-html="list"]');
    if (!target) return Promise.resolve();
    const sectionId = getCartSectionId();
    return fetch(window.location.pathname + '?sections=' + sectionId, {
      credentials: 'same-origin',
    })
      .then(function (res) { return res.json(); })
      .then(function (data) { applyCartPageSection(data && data[sectionId]); })
      .catch(function (err) {
        console.warn('[mini-cart] cart page refresh failed', err);
      });
  }

  function handleCartMutation(url) {
    const isAdd = /\/cart\/add\.js/.test(url);
    lastTriggerWasAdd = isAdd;

    if (reconciling) return;

    if (isAdd) {
      scheduleRefresh({ open: !isCartPage() });
      return;
    }

    reconcileAddons().then(function (removed) {
      scheduleRefresh({ open: false });
      if (removed && isCartPage()) refreshCartPage();
    });
  }

  document.addEventListener('product-form:cart:navigate', function (event) {
    event.preventDefault();
  });

  document.addEventListener('product-form:cart:update', function (event) {
    lastTriggerWasAdd = true;
    scheduleRefresh({ open: true, cart: event.detail && event.detail.cart });
  });

  const origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      const args = arguments;
      const input = args[0];
      let url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {
        url = '';
      }
      const promise = origFetch.apply(this, args);
      if (CART_MUTATION_RE.test(url)) {
        promise.then(function (res) {
          if (res && res.ok) handleCartMutation(url);
        }).catch(function () {});
      }
      return promise;
    };
  }

  const OrigXHR = window.XMLHttpRequest;
  if (OrigXHR) {
    const origOpen = OrigXHR.prototype.open;
    const origSend = OrigXHR.prototype.send;

    OrigXHR.prototype.open = function (method, url) {
      this.__liwUrl = url;
      return origOpen.apply(this, arguments);
    };

    OrigXHR.prototype.send = function () {
      const xhr = this;
      const url = xhr.__liwUrl || '';
      if (CART_MUTATION_RE.test(url)) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) handleCartMutation(url);
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  document.addEventListener('click', function (event) {
    const removeBtn = event.target.closest && event.target.closest('[data-mini-cart-remove]');
    if (!removeBtn) return;
    event.preventDefault();

    const keys = collectLinkedKeys(removeBtn);
    if (!keys.length) return;

    suppressOpenOnNextRefresh = false;
    setLoading(true);

    const onCart = isCartPage();
    const cartSectionId = getCartSectionId();
    const sections = onCart ? SECTION_ID + ',' + cartSectionId : SECTION_ID;

    batchRemove(keys, sections).then(function (cart) {
      if (!cart) {
        scheduleRefresh({ open: false });
        return;
      }
      const secs = cart.sections || {};
      applyDrawerSection(secs[SECTION_ID]);
      if (onCart) applyCartPageSection(secs[cartSectionId]);
      updateHeaderCount(parseCount(cart));
      setLoading(false);
    });
  });

  document.addEventListener('click', function (event) {
    if (!isCartPage()) return;
    const removeBtn = event.target.closest && event.target.closest('[data-cartitem-remove]');
    if (!removeBtn) return;

    const keys = collectLinkedKeys(removeBtn);
    if (keys.length < 2) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const cartSectionId = getCartSectionId();
    fadeElement(cartPageForm(), true);

    batchRemove(keys, cartSectionId).then(function (cart) {
      const applied = cart && applyCartPageSection(cart.sections && cart.sections[cartSectionId]);
      if (!applied) refreshCartPage();
      fadeElement(cartPageForm(), false);
    });
  }, true);

  window.LIW = window.LIW || {};
  window.LIW.miniCart = {
    open: function () {
      const d = getDrawer();
      if (d && typeof d.open === 'function') d.open();
    },
    close: function () {
      const d = getDrawer();
      if (d && typeof d.close === 'function') d.close();
    },
    refresh: function () { return refreshDrawer({ open: false }); },
    refreshAndOpen: function () { return refreshDrawer({ open: true }); },
  };

  function reconcileOnLoad() {
    reconcileAddons().then(function (removed) {
      if (!removed) return;
      scheduleRefresh({ open: false });
      if (isCartPage()) refreshCartPage();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcileOnLoad);
  } else {
    reconcileOnLoad();
  }
})();
